<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="form-container">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="160px"
      label-position="right"
      class="my-form"
    >
      <el-form-item label="名称：" prop="title">
        <el-input v-model.trim="form.title"></el-input>
      </el-form-item>
      <el-form-item label="采集方式：" prop="collect_type">
        <el-select v-model="form.collect_type" placeholder="请选择">
          <el-option
            v-for="item in collectType"
            :key="item.id"
            :label="item.label"
            :value="item.val"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合作方主体：" prop="company_subject">
        <el-input v-model.trim="form.company_subject"></el-input>
      </el-form-item>
      <el-form-item label="合作方隐私链接：" prop="secrecy_link">
        <el-input v-model.trim="form.secrecy_link"></el-input>
      </el-form-item>
      <el-form-item label="合作方官网链接：" prop="official_link">
        <el-input v-model.trim="form.official_link"></el-input>
      </el-form-item>
      <el-form-item label="涉及个人信息：" prop="involve_personal_info">
        <el-input
          type="textarea"
          v-model="form.involve_personal_info"
          maxlength="2000"
          show-word-limit
          :rows="5"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="使用目的：" prop="use_purpose">
        <el-input
          type="textarea"
          v-model="form.use_purpose"
          maxlength="2000"
          show-word-limit
          :rows="5"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="使用场景：" prop="use_scene">
        <el-input
          type="textarea"
          v-model="form.use_scene"
          maxlength="2000"
          show-word-limit
          :rows="5"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <div class="submitForm_btn">
          <el-button style="width: 130px" @click="backSdk">取消</el-button>
          <el-button
            style="margin-left: 50px; width: 130px"
            type="primary"
            @click="submitForm('form')"
            >确定</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      form: {
        title: "",
        collect_type: "",
        company_subject: "",
        secrecy_link: "",
        official_link: "",
        involve_personal_info: "",
        use_purpose: "",
        use_scene: "",
      },
      rules: {
        //名称校验
        title: [{ required: true, message: "名称为必填项", trigger: "blur" }],
        //采集方式校验
        collect_type: [
          { required: true, message: "采集方式为必选项", trigger: "change" },
        ],
        //合作方主体
        company_subject: [
          { required: true, message: "合作方主体为必填项", trigger: "blur" },
        ],
/*         //合作方隐私链接
        secrecy_link: [
          {
            required: true,
            message: "合作方隐私链接为必填项",
            trigger: "blur",
          },
        ],
        //合作方官网链接
        official_link: [
          {
            required: true,
            message: "合作方官网链接为必填项",
            trigger: "blur",
          },
        ],
        //涉及个人信息
        involve_personal_info: [
          { required: true, message: "涉及个人信息为必填项", trigger: "blur" },
        ], */
        //使用目的
        use_purpose: [
          { required: true, message: "使用目的为必填项", trigger: "blur" },
        ],
        //使用场景
        use_scene: [
          { required: true, message: "使用场景为必填项", trigger: "blur" },
        ],
      },
      fullscreenLoading: false,
    };
  },
  computed: {
    ...mapState({
      collectType: (state) => state.dict_main.collect_type,
    }),
  },
  mounted() {
    if (this.$route.query.editData) {
      this.form = this.$route.query.editData;
      this.form.update_time = "";
    }
  },
  methods: {
    // 表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            this.addSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 表格取消
    backSdk() {
      this.$router.push({
        path: "/manage_center/other/sdk",
      });
    },
    // 表单的添加
    async addSubmit() {
      const { form } = this;
      const [err, res] = await this.$http.post("Other/externalSdkAddChange", {
        ...form,
      });
      if (err) return;
      this.$message({
        message: "添加成功",
        type: "success",
      });
      this.$router.push({
        path: "/manage_center/other/sdk",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.form-container {
  display: flex;
  justify-content: center;
  //   align-items: center;
  //   height: 100vh; /* viewport height */
}
.my-form {
  width: 500px; /* Adjust this to suit your needs */
}
.el-select {
  width: 340px;
}
.el-form-item {
  margin-bottom: 38px;
}
.submitForm_btn {
  display: flex;
  justify-content: center;
}
</style>
